import { forwardRef, HTMLAttributes } from 'react';

import { cn, escapeRegExp } from '../../utils';

import { EmphasizedTextClassNames } from './constants';
import { TextMatch } from './EmphasizedText.styled';

export type EmphasizedTextProps = HTMLAttributes<HTMLSpanElement> & {
  text: string;
  match: string;
};

const EmphasizedText = forwardRef<HTMLSpanElement, EmphasizedTextProps>(
  (props, forwardedRef) => {
    const { match, text, className, ...rest } = props;

    const renderContent = () => {
      if (!match) return text;

      const escapedMatch = escapeRegExp(match);
      const matcher = new RegExp(`(${escapedMatch})`, 'i');

      const parts = text.split(matcher);

      return parts.map((part, index) =>
        matcher.test(part) ? (
          // eslint-disable-next-line react/no-array-index-key
          <TextMatch className={EmphasizedTextClassNames.Match} key={index}>
            {part}
          </TextMatch>
        ) : (
          part
        ),
      );
    };

    return (
      <span
        className={cn(EmphasizedTextClassNames.Root, className)}
        ref={forwardedRef}
        {...rest}>
        {renderContent()}
      </span>
    );
  },
);

export default EmphasizedText;
